// import hooks
import React, { useContext, useEffect, useState } from "react";

// import context
import { DatosInicioContext } from "../../context/DatosInicioContext";
import { DarkModeContext } from "../../context/DarkModeContext";

// import librerias
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

// import componentes
import BienvenidoPanel from "../../components/comunes/BienvenidoPanel";
import DatosAnalisis from "../../components/comunes/DatosAnalisis";
import EvolucionMensual3Barras from "../../components/comunes/EvolucionMensual3Barras";
import TripleGraficoAnalisis from "../../components/comunes/TripleGraficoAnalisis";
import ScrollToTopButton from "../../components/comunes/ScrollToTopButton";
import Footer from "../../components/comunes/Footer";
import "./Analisis.css";
import "./AliadoResponsive.css";

// import assets
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";
import { getToken } from "../../utils/auth";

const Analisis = () => {
  // datos extraidos desde el context
  const { datosAnalisisContext } = useContext(DatosInicioContext);

  // contexto para la modalidad claro/oscuro
  const { darkMode } = useContext(DarkModeContext);

  // hooks useNavigate para la navegacion
  const navegacion = useNavigate();

  // funcion para recargar la pagina
  function recargarPagina() {
    window.location.reload();
  }

  // url de la api token
  const apiUrlToken = process.env.REACT_APP_API_TOKEN;

  // estado para el spinner de carga
  const [cargando, setCargando] = useState(false);

  // consulta para verificar token
  useEffect(() => {
    const verificarToken = async () => {
      const token = getToken();

      if (!token) {
        manejarRespuestaNoAutorizada();
        return;
      }
      setCargando(true);
      try {
        const response = await fetch(apiUrlToken, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: token }),
        });

        if (response.ok) {
          const data = await response.json();

          if (data !== 0) {
            manejarAccesoDenegado();
          }
        } else {
          if (response.status === 401) {
            manejarRespuestaNoAutorizada();
          } else {
          }
        }
      } catch (error) {}
      setCargando(false);
    };

    // funcion para redireccionar al home
    const redireccionar = () => {
      navegacion("/");
      recargarPagina();
    };

    // funcion para manera el mensaje de respuesta no autorizada
    const manejarRespuestaNoAutorizada = () => {
      sessionStorage.removeItem("token");

      Swal.fire({
        title: "Sesión expirada o token inválido.",
        text: "Inicie sesión nuevamente.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode
            ? "swal2-container--dark"
            : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    // funcion para manera el mensaje de acceso denegado
    const manejarAccesoDenegado = () => {
      Swal.fire({
        title: "Sesión expirada o token inválido.",
        text: "Inicie sesión nuevamente.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode
            ? "swal2-container--dark"
            : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    verificarToken();
  }, []);

  if (cargando) {
    // Muestra el spinner mientras los datos se estan cargando
    return (
      <div
        className="spinner-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="">
          <div>
            <img
              className="img-fluid logo-width-spinner"
              src={darkMode ? logoClaro : logo}
              alt="logo SOCO"
            />
          </div>
          <div className="ms-3">
            <ThreeDots
              visible={true}
              height="60"
              width="60"
              color="#b4c400 "
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </div>
      </div>
    );
  }

  const today = new Date();

  return (
    <div
      className={darkMode ? "aliado-analisis aliado-analisis-dark" : "aliado-analisis"}
      translate="no"
    >
      <main className="aliado-analisis-shell">
        <header className="aliado-analisis-header">
          <div>
            <span className="aliado-analisis-kicker">CRM Aliado</span>
            <h1>Análisis</h1>
          </div>
          <div className="aliado-analisis-date">
            {today.toLocaleDateString("es-AR")} |{" "}
            {today.toLocaleTimeString("es-AR", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </header>
        <div className="aliado-analisis-filter">
          <BienvenidoPanel />
        </div>
        <ScrollToTopButton />
        <div className="aliado-analisis-kpis">
          <DatosAnalisis datosBack={datosAnalisisContext} />
        </div>
        <section className="aliado-analisis-chart-grid">
          <EvolucionMensual3Barras datosBack={datosAnalisisContext} />
          <TripleGraficoAnalisis datosBack={datosAnalisisContext} />
        </section>
        <div className="aliado-analisis-footer">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default Analisis;
